import React from 'react'
import { Link } from 'react-router-dom'
import MarketingSiteLayout from '../../marketing/MarketingSiteLayout'
import { PUBLIC_INQUIRY_PATH } from '../../marketing/marketingNav'
import LegalPolicyPublicSection from '../legal/LegalPolicyPublicSection'

const EFFECTIVE = '2026-04-17'

function RefundPolicyFallbackBody() {
  return (
    <>
      <p className="mt-4 text-sm text-slate-500">시행일 {EFFECTIVE} · 이용약관 제12조의 세부 기준입니다.</p>

      <div className="mt-10 space-y-10 text-sm leading-7 text-slate-700">
        <section>
          <h2 className="text-lg font-bold text-slate-900">1. 적용 범위</h2>
          <ul className="mt-3 list-disc space-y-2 pl-5">
            <li>본 정책은 설계 EZ(이하 회사)가 제공하는 유료 구독, 유상 포인트(충전형) 및 이에 부수하는 결제에 적용됩니다.</li>
            <li>조직(GA 등) 별도 계약·견적·세금계산서 기준 거래는 계약서 또는 별도 안내가 우선합니다.</li>
            <li>관련 법령에서 소비자에게 유리한 규정이 있는 경우 그에 따릅니다.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900">2. 구독(기간형 이용권)</h2>
          <h3 className="mt-4 font-semibold text-slate-800">2.1 해지</h3>
          <p className="mt-2">
            회원은 구독 기간 중 회사가 정한 방법(서비스 내 설정, 고객문의 등)으로 해지를 요청할 수 있습니다. 기간 선결제형인 경우, 별도 안내가 없는 한
            이미 결제된 기간의 만료일까지는 이용 권한이 유지될 수 있습니다.
          </p>
          <h3 className="mt-6 font-semibold text-slate-800">2.2 환불 원칙</h3>
          <ul className="mt-2 list-disc space-y-2 pl-5">
            <li>
              <strong className="text-slate-900">결제 완료 후 7일 이내</strong>이고, 회사가 정한 유료 혜택(예: 유료 기능의 실질적 이용, 할당량 소진,
              보너스 포인트 지급·사용 등)이 없었다고 인정되는 경우에는 원칙적으로 <strong className="text-slate-900">전액 환불</strong>을 요청할 수
              있습니다.
            </li>
            <li>그 외에는 미제공·미사용 기간에 대한 부분 환불을 제공할 수 있으며, 이미 제공된 혜택·할인·보너스는 환불 금액에서 공제할 수 있습니다.</li>
            <li>쿠폰·단체할인·프로모션이 적용된 주문은 할인액·이미 사용된 혜택을 반영하여 환불 금액이 조정될 수 있습니다.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900">3. 포인트</h2>
          <ul className="mt-3 list-disc space-y-2 pl-5">
            <li>
              <strong className="text-slate-900">보너스 포인트</strong>(무상 지급·프로모션 등)는 원칙적으로 현금 환불되지 않으며, 회수·차감될 수
              있습니다.
            </li>
            <li>
              <strong className="text-slate-900">구매 포인트</strong>는 관련 법령 및 회사 정책에 따라 미사용 잔액에 한해 환불을 요청할 수 있습니다. 이미
              사용된 포인트는 환불 대상에서 제외됩니다.
            </li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900">4. 신청 방법 및 처리</h2>
          <ul className="mt-3 list-disc space-y-2 pl-5">
            <li>
              환불·취소 요청: 서비스 내 <strong className="text-slate-900">고객문의</strong> 또는 이메일{' '}
              <a className="font-semibold text-brand-navy underline" href="mailto:support@sgez.co.kr">
                support@sgez.co.kr
              </a>
            </li>
            <li>
              공개 문의:{' '}
              <Link className="font-semibold text-brand-navy underline" to={PUBLIC_INQUIRY_PATH}>
                문의하기
              </Link>
              (비회원 가능, 유료 결제·환불 식별을 위해 회원 정보를 함께 남겨 주세요.)
            </li>
            <li>회사는 요청 접수 후 내부 검토(이용 이력·결제 원장 확인 등)를 거쳐 승인 또는 불가 사유를 안내합니다.</li>
            <li>환불이 승인된 경우, 결제 수단·PG·카드사 정책에 따라 실제 입금까지 수일이 소요될 수 있습니다.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-lg font-bold text-slate-900">5. 제한·불가 사유(예시)</h2>
          <ul className="mt-3 list-disc space-y-2 pl-5">
            <li>약관 위반·부정 이용이 확인되어 이용이 제한된 경우</li>
            <li>이미 전부 사용·소진된 디지털 혜택에 대해 청약철회가 제한되는 등 법령상 제한이 있는 경우</li>
            <li>조직 계약·별도 견적에 따라 환불이 배제되거나 별도 규정이 있는 경우</li>
          </ul>
        </section>

        <section className="rounded-2xl border border-amber-200 bg-amber-50/80 px-4 py-4 text-xs leading-relaxed text-amber-950">
          본 정책은 서비스 운영을 위한 안내이며, 상품·요금·환불 조건은 도입 시 공지·계약에 따라 조정될 수 있습니다. 최종 적용 전 법률·PG 정책에 맞춰
          검토·개정할 수 있습니다.
        </section>

        <div className="flex flex-wrap gap-3 border-t border-slate-200 pt-8 text-sm">
          <Link to="/terms" className="font-semibold text-brand-navy underline-offset-2 hover:underline">
            이용약관
          </Link>
          <Link to="/privacy" className="font-semibold text-brand-navy underline-offset-2 hover:underline">
            개인정보처리방침
          </Link>
          <Link to="/checkout" className="font-semibold text-brand-navy underline-offset-2 hover:underline">
            결제 안내
          </Link>
        </div>
      </div>
    </>
  )
}

export default function RefundPolicyPage() {
  return (
    <MarketingSiteLayout>
      <div className="mx-auto max-w-3xl px-4 py-14 md:py-20">
        <p className="text-xs font-bold uppercase tracking-[0.28em] text-brand-sky">정책</p>
        <h1 className="mt-4 text-3xl font-black tracking-tight text-slate-900 sm:text-4xl">청약철회·결제 취소 및 환불 정책</h1>

        <div className="mt-6">
          <LegalPolicyPublicSection
            docCode="REFUND_POLICY"
            fallback={
              <>
                <p className="text-xs text-slate-400">게시본이 없을 때 표시되는 내장 폴백입니다.</p>
                <RefundPolicyFallbackBody />
              </>
            }
          />
        </div>
      </div>
    </MarketingSiteLayout>
  )
}
